/* Cart Upsell Carousel — Zeno
   ----------------------------------
   Cards are rendered server-side in cart-upsell.liquid. This script
   handles: the scroll-position bar under the heading (a proper
   scrollbar-style thumb — fixed width representing how much of the
   row is visible, sliding left-to-right as you scroll, NOT a growing
   loading-bar fill), the scroll-hint fade/chevron, mouse click-and-drag
   scrolling of the card list on desktop, the size-picker overlay toggle
   for single-option products, and the actual "add to cart" AJAX call
   (used by both the plain "+" button and the in-picker size buttons —
   they share the [data-cart-upsell-add] hook). */

(function () {
  function refreshDrawer(cartResponse) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(cartResponse);
      return true;
    }
    return false;
  }

  function addToCart(variantId, button) {
    var root = button.closest('[data-cart-upsell]');
    if (!root) return;

    button.disabled = true;
    var originalLabel = button.innerHTML;
    button.innerHTML = '<span aria-hidden="true">…</span>';

    fetch(root.getAttribute('data-cart-add-url') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          button.innerHTML = '<span aria-hidden="true">×</span>';
          setTimeout(function () {
            button.innerHTML = originalLabel;
            button.disabled = false;
          }, 1500);
          return;
        }
        var refreshed = data.sections && refreshDrawer(data);
        if (!refreshed) {
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        }
      })
      .catch(function () {
        button.innerHTML = originalLabel;
        button.disabled = false;
      });
  }

  function closeAllPickers(except) {
    document.querySelectorAll('[data-cart-upsell-picker]').forEach(function (picker) {
      if (picker !== except) picker.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-upsell-toggle-picker]');
    if (toggle) {
      var media = toggle.closest('.cart-upsell__card').querySelector('[data-cart-upsell-picker]');
      if (media) {
        var willOpen = media.hidden;
        closeAllPickers();
        media.hidden = !willOpen;
      }
      return;
    }

    var addButton = event.target.closest('[data-cart-upsell-add]');
    if (addButton) {
      var variantId = addButton.getAttribute('data-variant-id');
      if (variantId) addToCart(variantId, addButton);
      return;
    }

    // Click outside any card closes open pickers
    if (!event.target.closest('.cart-upsell__card')) {
      closeAllPickers();
    }
  });

  function initProgress(root) {
    var list = root.querySelector('[data-cart-upsell-list]');
    var fill = root.querySelector('[data-cart-upsell-progress]');
    var track = root.querySelector('[data-cart-upsell-progress-track]');
    var wrapper = root.querySelector('[data-cart-upsell-list-wrapper]');
    if (!list || !fill) return;
    if (list.dataset.zenoProgressInit) return; // avoid re-attaching duplicate listeners
    list.dataset.zenoProgressInit = 'true';

    // Zeno: proper scrollbar-thumb math — the thumb's WIDTH represents
    // how much of the row is visible at once (clientWidth / scrollWidth),
    // and its POSITION (translateX) represents how far scrolled. A fixed
    // ~30% width thumb sliding across the track, matching a native
    // scrollbar, instead of a bar that grows from 0% to 100%.
    //
    // The cart drawer is collapsed (effectively zero-size) until it's
    // opened, so the very first calculation on page load can run against
    // list.scrollWidth === 0 — dividing by that gives NaN, which silently
    // fails to apply any CSS width at all, leaving the thumb permanently
    // stuck invisible even after the drawer opens and real dimensions
    // exist. Guarded against below, and re-measured via ResizeObserver
    // (which fires exactly when the drawer transitions from collapsed to
    // its real open size — scroll/resize alone don't catch that moment).
    function update() {
      if (!list.scrollWidth) return; // nothing to measure yet (drawer still collapsed)

      var scrollable = list.scrollWidth - list.clientWidth;
      var trackWidth = track ? track.clientWidth : list.clientWidth;
      if (!trackWidth) return;

      var thumbPercent = Math.min(1, list.clientWidth / list.scrollWidth);
      var thumbWidth = Math.max(trackWidth * thumbPercent, 24); // px floor so it stays grabbable
      var scrollPercent = scrollable > 0 ? list.scrollLeft / scrollable : 0;
      var maxOffset = Math.max(trackWidth - thumbWidth, 0);

      fill.style.width = thumbWidth + 'px';
      fill.style.transform = 'translateX(' + scrollPercent * maxOffset + 'px)';

      if (track) {
        track.style.display = scrollable > 4 ? '' : 'none';
      }

      if (wrapper) {
        var atEnd = scrollable <= 1 || list.scrollLeft >= scrollable - 1;
        wrapper.classList.toggle('is-at-end', atEnd);
      }
    }

    list.addEventListener('scroll', update, { passive: true });
    update();
    window.addEventListener('resize', update);

    // Catches the drawer opening (collapsed -> real size) regardless of
    // however Dawn implements that transition internally (class toggle,
    // attribute, transform) — ResizeObserver just watches the actual box
    // size, so it fires exactly when it matters.
    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(list);
      if (track) resizeObserver.observe(track);
    }

    // Zeno: the progress bar itself is draggable — clicking/dragging
    // anywhere on the track jumps the list's scroll position to match,
    // like a scrubber. Works with mouse, touch, and pen via Pointer
    // Events, so it behaves the same on desktop and mobile.
    if (track) {
      var scrubbing = false;

      function scrubTo(clientX) {
        var rect = track.getBoundingClientRect();
        var percent = (clientX - rect.left) / rect.width;
        percent = Math.max(0, Math.min(1, percent));
        var scrollable = list.scrollWidth - list.clientWidth;
        list.scrollLeft = percent * scrollable;
      }

      track.addEventListener('pointerdown', function (event) {
        scrubbing = true;
        track.setPointerCapture(event.pointerId);
        scrubTo(event.clientX);
      });

      track.addEventListener('pointermove', function (event) {
        if (!scrubbing) return;
        scrubTo(event.clientX);
      });

      function stopScrubbing() {
        scrubbing = false;
      }

      track.addEventListener('pointerup', stopScrubbing);
      track.addEventListener('pointercancel', stopScrubbing);
    }

    // Zeno: click-and-drag to scroll the card list itself with a
    // mouse — native overflow-x:auto only responds to touch/trackpad/
    // wheel by default, not a mouse click-drag, so this is what makes
    // it actually draggable on desktop. A small movement threshold
    // keeps normal clicks (the "+" button, the size picker) working
    // instead of being swallowed as a drag.
    var isPointerDown = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var DRAG_THRESHOLD = 6;

    list.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return; // native touch scroll already works
      isPointerDown = true;
      isDragging = false;
      dragStartX = event.clientX;
      dragStartScrollLeft = list.scrollLeft;
    });

    list.addEventListener('pointermove', function (event) {
      if (!isPointerDown) return;
      var delta = event.clientX - dragStartX;
      if (!isDragging && Math.abs(delta) > DRAG_THRESHOLD) {
        isDragging = true;
        list.classList.add('is-dragging');
        list.setPointerCapture(event.pointerId);
      }
      if (isDragging) {
        list.scrollLeft = dragStartScrollLeft - delta;
      }
    });

    function endDrag() {
      isPointerDown = false;
      if (isDragging) {
        isDragging = false;
        list.classList.remove('is-dragging');
      }
    }

    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
    list.addEventListener('pointerleave', endDrag);

    // Suppress the click that would otherwise fire on a card/button
    // right after a drag ends, so dragging past a product doesn't
    // accidentally trigger add-to-cart or open its size picker.
    list.addEventListener(
      'click',
      function (event) {
        if (isDragging) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-cart-upsell]').forEach(function (root) {
      initProgress(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The drawer re-renders this whole block server-side on every cart
  // change (see cart-drawer.js renderContents), which re-inserts a fresh
  // [data-cart-upsell-list] with scrollLeft reset to 0 — reattach the
  // progress-bar listener each time.
  var drawer = document.querySelector('cart-drawer, #CartDrawer');
  if (drawer && window.MutationObserver) {
    var observer = new MutationObserver(initAll);
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
